export enum FugitiveCategory {
  FC_1 = 'FC_1',
  FC_2 = 'FC_2',
  FC_3 = 'FC_3',
  FC_4 = 'FC_4',
  FC_5 = 'FC_5',
  FC_6 = 'FC_6',
  FC_7 = 'FC_7',
  FC_8 = 'FC_8',
  FC_9 = 'FC_9',
  FC_10 = 'FC_10',
  FC_11 = 'FC_11',
  FC_12 = 'FC_12',
  FC_13 = 'FC_13',
  FC_14 = 'FC_14',
  FC_15 = 'FC_15',
  FC_OT = 'FC_OT',
  JP_FC_1 = 'JP_FC_1',
  JP_FC_2 = 'JP_FC_2',
  JP_FC_3 = 'JP_FC_3',
  JP_FC_4 = 'JP_FC_4',
  JP_FC_5 = 'JP_FC_5',
  JP_FC_6 = 'JP_FC_6',
  JP_FC_7 = 'JP_FC_7',
  JP_FC_8 = 'JP_FC_8',
  JP_FC_9 = 'JP_FC_9',
  JP_FC_10 = 'JP_FC_10',
  JP_FC_OT = 'JP_FC_OT',
  IN_FC_1 = 'IN_FC_1',
  CA_FC_1 = 'CA_FC_1',
  SG_FC_1 = 'SG_FC_1',
  ADEME_FC_4 = 'ADEME_FC_4',
  MX_FC_2 = 'MX_FC_2',
}

export enum FugitiveType {
  FT_3_1 = 'FT_3_1',
  FT_4_1 = 'FT_4_1',
  FT_4_2 = 'FT_4_2',
  FT_4_3 = 'FT_4_3',
  FT_4_4 = 'FT_4_4',
  FT_4_5 = 'FT_4_5',

  FT_4_6 = 'FT_4_6',
  FT_4_7 = 'FT_4_7',
  FT_4_8 = 'FT_4_8',
  FT_4_9 = 'FT_4_9',
  FT_4_10 = 'FT_4_10',

  FT_7_1 = 'FT_7_1',
  FT_8_1 = 'FT_8_1',
  FT_8_2 = 'FT_8_2',
  FT_8_3 = 'FT_8_3',
  FT_8_4 = 'FT_8_4',
  FT_8_5 = 'FT_8_5',
  FT_8_6 = 'FT_8_6',
  FT_8_7 = 'FT_8_7',
  FT_14_1 = 'FT_14_1',
  FT_14_2 = 'FT_14_2',

  ADEME_FT_4_1 = 'ADEME_FT_4_1',
  FT_OTHER = 'FT_OTHER',

  FC_7_1 = 'FC_7_1',
  FC_7_2 = 'FC_7_2',
  FC_7_3 = 'FC_7_3',
  FC_7_4 = 'FC_7_4',
  FC_7_5 = 'FC_7_5',
  FC_7_6 = 'FC_7_6',
  FC_6_1 = 'FC_6_1',
  FC_6_2 = 'FC_6_2',
  FC_6_3 = 'FC_6_3',
  FC_6_4 = 'FC_6_4',
  FC_12_1 = 'FC_12_1',
  FC_12_2 = 'FC_12_2',
  FC_12_3 = 'FC_12_3',
  FC_12_4 = 'FC_12_4',
  FC_12_5 = 'FC_12_5',
  FC_12_6 = 'FC_12_6',
  FC_12_7 = 'FC_12_7',
  FC_12_8 = 'FC_12_8',
  FC_12_9 = 'FC_12_9',
  FC_12_10 = 'FC_12_10',
  FC_12_11 = 'FC_12_11',
  FC_12_12 = 'FC_12_12',
  FC_13_1 = 'FC_13_1',
  FC_13_2 = 'FC_13_2',
  JP_FC_1_1 = 'JP_FC_1_1',
  JP_FC_1_2 = 'JP_FC_1_2',
  JP_FC_1_3 = 'JP_FC_1_3',
  JP_FC_1_4 = 'JP_FC_1_4',
  JP_FC_1_5 = 'JP_FC_1_5',
  JP_FC_1_6 = 'JP_FC_1_6',
  JP_FC_1_7 = 'JP_FC_1_7',
  JP_FC_1_8 = 'JP_FC_1_8',
  JP_FC_1_9 = 'JP_FC_1_9',
  JP_FC_1_10 = 'JP_FC_1_10',
  JP_FC_1_11 = 'JP_FC_1_11',
  JP_FC_1_12 = 'JP_FC_1_12',
  JP_FC_1_13 = 'JP_FC_1_13',
  JP_FC_1_14 = 'JP_FC_1_14',
  JP_FC_1_15 = 'JP_FC_1_15',
  JP_FC_1_16 = 'JP_FC_1_16',
  JP_FC_1_17 = 'JP_FC_1_17',
  JP_FC_1_18 = 'JP_FC_1_18',
  JP_FC_1_19 = 'JP_FC_1_19',
  JP_FC_1_20 = 'JP_FC_1_20',
  JP_FC_1_21 = 'JP_FC_1_21',
  JP_FC_1_22 = 'JP_FC_1_22',
  JP_FC_1_23 = 'JP_FC_1_23',
  JP_FC_1_24 = 'JP_FC_1_24',
  JP_FC_1_25 = 'JP_FC_1_25',
  FC_9_1 = 'FC_9_1',
  FC_9_2 = 'FC_9_2',
  FC_9_3 = 'FC_9_3',
  FC_9_4 = 'FC_9_4',
  FC_9_5 = 'FC_9_5',
  FC_9_6 = 'FC_9_6',
  FC_9_7 = 'FC_9_7',
  FC_9_8 = 'FC_9_8',
  FC_9_9 = 'FC_9_9',
  FC_9_10 = 'FC_9_10',
  FC_9_11 = 'FC_9_11',
  FC_9_12 = 'FC_9_12',
  FC_9_13 = 'FC_9_13',
  FC_9_14 = 'FC_9_14',
  FC_9_15 = 'FC_9_15',
  FC_9_16 = 'FC_9_16',
  FC_9_17 = 'FC_9_17',
  FC_9_18 = 'FC_9_18',
  FC_9_19 = 'FC_9_19',
  FC_9_20 = 'FC_9_20',
  FC_9_21 = 'FC_9_21',
  FC_9_22 = 'FC_9_22',
  FC_9_23 = 'FC_9_23',
  FC_9_24 = 'FC_9_24',
  FC_9_25 = 'FC_9_25',
  FC_9_26 = 'FC_9_26',
  FC_9_27 = 'FC_9_27',
  FC_9_28 = 'FC_9_28',
  FC_9_29 = 'FC_9_29',
  FC_9_30 = 'FC_9_30',
  FC_9_31 = 'FC_9_31',
  FC_9_32 = 'FC_9_32',
  FC_9_33 = 'FC_9_33',
  FC_9_34 = 'FC_9_34',
  FC_9_35 = 'FC_9_35',
  FC_9_36 = 'FC_9_36',
  FC_9_37 = 'FC_9_37',
  FC_9_38 = 'FC_9_38',
  FC_9_39 = 'FC_9_39',
  FC_9_40 = 'FC_9_40',
  FC_9_41 = 'FC_9_41',
  FC_9_42 = 'FC_9_42',
  FC_9_43 = 'FC_9_43',
  FC_9_44 = 'FC_9_44',
  FC_9_45 = 'FC_9_45',
  FC_9_46 = 'FC_9_46',
  FC_9_47 = 'FC_9_47',
  FC_9_48 = 'FC_9_48',
  FC_9_49 = 'FC_9_49',
  FC_9_50 = 'FC_9_50',
  FC_9_51 = 'FC_9_51',
  FC_9_52 = 'FC_9_52',
  FC_9_53 = 'FC_9_53',
  FC_9_54 = 'FC_9_54',
  FC_9_55 = 'FC_9_55',
  FC_9_56 = 'FC_9_56',
  FC_9_57 = 'FC_9_57',
  FC_9_58 = 'FC_9_58',
  FC_9_59 = 'FC_9_59',
  FC_10_1 = 'FC_10_1',
  FC_10_2 = 'FC_10_2',
  FC_10_3 = 'FC_10_3',
  FC_10_4 = 'FC_10_4',
  FC_10_5 = 'FC_10_5',
  FC_10_6 = 'FC_10_6',
  FC_10_7 = 'FC_10_7',
  FC_10_8 = 'FC_10_8',
  FC_10_9 = 'FC_10_9',
  FC_10_10 = 'FC_10_10',
  FC_10_11 = 'FC_10_11',
  FC_10_12 = 'FC_10_12',
  FC_10_13 = 'FC_10_13',
  FC_10_14 = 'FC_10_14',
  FC_10_15 = 'FC_10_15',
  FC_10_16 = 'FC_10_16',
  FC_10_17 = 'FC_10_17',
  FC_10_18 = 'FC_10_18',
  FC_10_19 = 'FC_10_19',
  FC_10_20 = 'FC_10_20',
  FC_10_21 = 'FC_10_21',
  FC_10_22 = 'FC_10_22',
  FC_10_23 = 'FC_10_23',
  FC_10_24 = 'FC_10_24',
  FC_10_25 = 'FC_10_25',
  FC_10_26 = 'FC_10_26',
  FC_10_27 = 'FC_10_27',
  FC_10_28 = 'FC_10_28',
  FC_10_29 = 'FC_10_29',
  FC_10_30 = 'FC_10_30',
  FC_10_31 = 'FC_10_31',
  FC_10_32 = 'FC_10_32',
  FC_10_33 = 'FC_10_33',
  FC_10_34 = 'FC_10_34',
  FC_10_35 = 'FC_10_35',
  FC_10_36 = 'FC_10_36',
  FC_10_37 = 'FC_10_37',
  FC_10_38 = 'FC_10_38',
  FC_10_39 = 'FC_10_39',
  FC_10_40 = 'FC_10_40',
  FC_10_41 = 'FC_10_41',
  FC_10_42 = 'FC_10_42',
  FC_10_43 = 'FC_10_43',
  FC_10_44 = 'FC_10_44',
  FC_10_45 = 'FC_10_45',
  FC_10_46 = 'FC_10_46',
  FC_10_47 = 'FC_10_47',
  FC_10_48 = 'FC_10_48',
  FC_10_49 = 'FC_10_49',
  FC_10_50 = 'FC_10_50',
  FC_10_51 = 'FC_10_51',
  FC_10_52 = 'FC_10_52',
  FC_10_53 = 'FC_10_53',
  FC_10_54 = 'FC_10_54',
  FC_10_55 = 'FC_10_55',
  FC_10_56 = 'FC_10_56',
  FC_10_57 = 'FC_10_57',
  FC_10_58 = 'FC_10_58',
  FC_10_59 = 'FC_10_59',
  FC_10_60 = 'FC_10_60',
  FC_10_61 = 'FC_10_61',
  FC_10_62 = 'FC_10_62',
  FC_10_63 = 'FC_10_63',
  FC_10_64 = 'FC_10_64',
  FC_10_65 = 'FC_10_65',
  FC_10_66 = 'FC_10_66',
  FC_10_67 = 'FC_10_67',
  FC_10_68 = 'FC_10_68',
  FC_10_69 = 'FC_10_69',
  FC_10_70 = 'FC_10_70',
  FC_10_71 = 'FC_10_71',
  FC_10_72 = 'FC_10_72',
  FC_10_73 = 'FC_10_73',
  FC_10_74 = 'FC_10_74',
  FC_10_75 = 'FC_10_75',
  FC_10_76 = 'FC_10_76',
  FC_10_77 = 'FC_10_77',
  FC_10_78 = 'FC_10_78',
  FC_10_79 = 'FC_10_79',
  FC_10_80 = 'FC_10_80',
  FC_10_81 = 'FC_10_81',
  FC_10_82 = 'FC_10_82',
  FC_10_83 = 'FC_10_83',
  FC_10_84 = 'FC_10_84',
  FC_10_85 = 'FC_10_85',
  FC_3_1 = 'FC_3_1',
  FC_OT_1 = 'FC_OT_1',
  FC_OT_2 = 'FC_OT_2',
  FC_OT_3 = 'FC_OT_3',
  FC_OT_4 = 'FC_OT_4',
  FC_OT_5 = 'FC_OT_5',
  FC_14_1 = 'FC_14_1',
  FC_14_2 = 'FC_14_2',
  FC_14_3 = 'FC_14_3',
  FC_14_4 = 'FC_14_4',
  FC_14_5 = 'FC_14_5',
  FC_14_6 = 'FC_14_6',
  FC_14_7 = 'FC_14_7',
  FC_14_8 = 'FC_14_8',
  FC_14_9 = 'FC_14_9',
  FC_14_10 = 'FC_14_10',
  FC_14_11 = 'FC_14_11',
  FC_14_12 = 'FC_14_12',
  FC_14_13 = 'FC_14_13',
  FC_14_14 = 'FC_14_14',
  FC_14_15 = 'FC_14_15',
}

export enum FugitiveEquipmentType {
  // IN_ET_1_4
  IN_ET_1 = 'IN_ET_1',
  IN_ET_2 = 'IN_ET_2',
  IN_ET_3 = 'IN_ET_3',
  IN_ET_4 = 'IN_ET_4',
  IN_ET_5 = 'IN_ET_5',
  IN_ET_6 = 'IN_ET_6',
  IN_ET_7 = 'IN_ET_7',
  IN_ET_8 = 'IN_ET_8',
  IN_ET_9 = 'IN_ET_9',
  IN_ET_10 = 'IN_ET_10',
  IN_ET_11 = 'IN_ET_11',
  IN_ET_12 = 'IN_ET_12',
  IN_ET_13 = 'IN_ET_13',
  IN_ET_14 = 'IN_ET_14',
  IN_ET_15 = 'IN_ET_15',
  IN_ET_16 = 'IN_ET_16',
  IN_ET_17 = 'IN_ET_17',
  IN_ET_18 = 'IN_ET_18',
  IN_ET_19 = 'IN_ET_19',
  IN_ET_20 = 'IN_ET_20',
  IN_ET_21 = 'IN_ET_21',
  IN_ET_22 = 'IN_ET_22',
  IN_ET_23 = 'IN_ET_23',

  // FT_3_1
  ET_1 = 'ET_1',
  ET_2 = 'ET_2',
  ET_3 = 'ET_3',
  ET_4 = 'ET_4',
  ET_5 = 'ET_5',
  ET_6 = 'ET_6',

  // FT_4_1
  ET_7 = 'ET_7',
  ET_8 = 'ET_8',
  ET_9 = 'ET_9',
  ET_10 = 'ET_10',
  ET_11 = 'ET_11',
  ET_12 = 'ET_12',
  ET_13 = 'ET_13',
  ET_14 = 'ET_14',

  // FT_4_2
  ET_15 = 'ET_15',
  ET_16 = 'ET_16',
  ET_17 = 'ET_17',
  ET_18 = 'ET_18',
  ET_19 = 'ET_19',
  ET_20 = 'ET_20',
  ET_21 = 'ET_21',
  ET_22 = 'ET_22',

  // FT_4_3
  ET_23 = 'ET_23',
  ET_24 = 'ET_24',
  ET_25 = 'ET_25',
  ET_26 = 'ET_26',
  ET_27 = 'ET_27',
  ET_28 = 'ET_28',
  ET_29 = 'ET_29',
  ET_30 = 'ET_30',

  // FT_4_4
  ET_31 = 'ET_31',
  ET_32 = 'ET_32',
  ET_33 = 'ET_33',
  ET_34 = 'ET_34',
  ET_35 = 'ET_35',
  ET_36 = 'ET_36',
  ET_37 = 'ET_37',
  ET_38 = 'ET_38',

  // FT_4_5
  ET_39 = 'ET_39',
  ET_40 = 'ET_40',
  ET_41 = 'ET_41',
  ET_42 = 'ET_42',
  ET_43 = 'ET_43',
  ET_44 = 'ET_44',
  ET_45 = 'ET_45',
  ET_46 = 'ET_46',

  // FT_4_6
  ET_47 = 'ET_47',
  ET_48 = 'ET_48',
  ET_49 = 'ET_49',
  ET_50 = 'ET_50',
  ET_51 = 'ET_51',
  ET_52 = 'ET_52',
  ET_53 = 'ET_53',
  ET_54 = 'ET_54',

  // FT_7_1
  ET_55 = 'ET_55',

  // FT_14_1
  ET_70 = 'ET_70',
  ET_71 = 'ET_71',
  ET_72 = 'ET_72',
  ET_73 = 'ET_73',
  ET_74 = 'ET_74',
  ET_75 = 'ET_75',

  // FT_14_2
  ET_76 = 'ET_76',
  ET_77 = 'ET_77',
  ET_78 = 'ET_78',
  ET_79 = 'ET_79',
  ET_80 = 'ET_80',
  ET_81 = 'ET_81',
  ET_82 = 'ET_82',

  ET_OTHER = 'ET_OTHER',
}

export enum RefrigerantGHG {
  NA = 'NA',
  GHG_1 = 'GHG_1',
  GHG_2 = 'GHG_2',
  GHG_3 = 'GHG_3',
  GHG_4 = 'GHG_4',
  GHG_5 = 'GHG_5',
  GHG_6 = 'GHG_6',
  GHG_7 = 'GHG_7',
  GHG_8 = 'GHG_8',
  GHG_9 = 'GHG_9',
  GHG_10 = 'GHG_10',
  GHG_11 = 'GHG_11',
  GHG_12 = 'GHG_12',
  GHG_13 = 'GHG_13',
  GHG_14 = 'GHG_14',
  GHG_15 = 'GHG_15',
  GHG_16 = 'GHG_16',
  GHG_17 = 'GHG_17',
  GHG_18 = 'GHG_18',
  GHG_19 = 'GHG_19',
  GHG_20 = 'GHG_20',
  GHG_21 = 'GHG_21',
  GHG_22 = 'GHG_22',
  GHG_23 = 'GHG_23',
  GHG_24 = 'GHG_24',
  GHG_25 = 'GHG_25',
  GHG_26 = 'GHG_26',
  GHG_27 = 'GHG_27',
  GHG_28 = 'GHG_28',
  GHG_29 = 'GHG_29',
  GHG_30 = 'GHG_30',
  GHG_31 = 'GHG_31',
  GHG_32 = 'GHG_32',
  GHG_33 = 'GHG_33',
  GHG_34 = 'GHG_34',
  GHG_35 = 'GHG_35',
  GHG_36 = 'GHG_36',
  GHG_37 = 'GHG_37',
  GHG_38 = 'GHG_38',
  GHG_39 = 'GHG_39',
  GHG_40 = 'GHG_40',
  GHG_41 = 'GHG_41',
  GHG_42 = 'GHG_42',
  GHG_43 = 'GHG_43',
  GHG_44 = 'GHG_44',
  GHG_45 = 'GHG_45',
  GHG_46 = 'GHG_46',
  GHG_47 = 'GHG_47',
  GHG_48 = 'GHG_48',
  GHG_49 = 'GHG_49',
  GHG_50 = 'GHG_50',
  GHG_51 = 'GHG_51',
  GHG_52 = 'GHG_52',
  GHG_53 = 'GHG_53',
  GHG_54 = 'GHG_54',
  GHG_55 = 'GHG_55',
  GHG_56 = 'GHG_56',
  GHG_57 = 'GHG_57',
  GHG_58 = 'GHG_58',
  GHG_59 = 'GHG_59',
  GHG_60 = 'GHG_60',
  GHG_61 = 'GHG_61',
  GHG_62 = 'GHG_62',
  GHG_63 = 'GHG_63',
  GHG_64 = 'GHG_64',
  GHG_65 = 'GHG_65',
  GHG_66 = 'GHG_66',
  GHG_67 = 'GHG_67',
  GHG_68 = 'GHG_68',
  GHG_69 = 'GHG_69',
  GHG_70 = 'GHG_70',
  GHG_71 = 'GHG_71',
  GHG_72 = 'GHG_72',
  GHG_73 = 'GHG_73',
  GHG_74 = 'GHG_74',
  GHG_75 = 'GHG_75',
  GHG_76 = 'GHG_76',
  GHG_77 = 'GHG_77',
  GHG_78 = 'GHG_78',
  GHG_79 = 'GHG_79',
  GHG_80 = 'GHG_80',
  GHG_81 = 'GHG_81',
  GHG_82 = 'GHG_82',
  GHG_83 = 'GHG_83',
  GHG_84 = 'GHG_84',
  GHG_85 = 'GHG_85',
  GHG_86 = 'GHG_86',
  GHG_87 = 'GHG_87',
  GHG_88 = 'GHG_88',
  GHG_89 = 'GHG_89',
  GHG_90 = 'GHG_90',
  GHG_91 = 'GHG_91',
  GHG_92 = 'GHG_92',
  GHG_93 = 'GHG_93',
  GHG_94 = 'GHG_94',
  GHG_95 = 'GHG_95',
  GHG_96 = 'GHG_96',
  GHG_97 = 'GHG_97',
  GHG_98 = 'GHG_98',
  GHG_99 = 'GHG_99',
  GHG_100 = 'GHG_100',
  GHG_101 = 'GHG_101',
  GHG_102 = 'GHG_102',
  GHG_103 = 'GHG_103',
  GHG_104 = 'GHG_104',
  GHG_105 = 'GHG_105',
  GHG_106 = 'GHG_106',
  GHG_107 = 'GHG_107',
  GHG_108 = 'GHG_108',
  GHG_109 = 'GHG_109',
  GHG_110 = 'GHG_110',
  GHG_111 = 'GHG_111',
  GHG_112 = 'GHG_112',
  GHG_113 = 'GHG_113',
  GHG_114 = 'GHG_114',
  GHG_115 = 'GHG_115',
  GHG_116 = 'GHG_116',
  GHG_117 = 'GHG_117',
  GHG_118 = 'GHG_118',
  GHG_119 = 'GHG_119',
  GHG_120 = 'GHG_120',
  GHG_121 = 'GHG_121',
  GHG_122 = 'GHG_122',
  GHG_123 = 'GHG_123',
  GHG_124 = 'GHG_124',
  GHG_125 = 'GHG_125',
  GHG_126 = 'GHG_126',
  GHG_127 = 'GHG_127',
  GHG_128 = 'GHG_128',
  GHG_129 = 'GHG_129',
  GHG_130 = 'GHG_130',
  GHG_131 = 'GHG_131',
  GHG_132 = 'GHG_132',
  GHG_133 = 'GHG_133',
  GHG_134 = 'GHG_134',
  GHG_135 = 'GHG_135',
  GHG_136 = 'GHG_136',
  GHG_137 = 'GHG_137',
  GHG_138 = 'GHG_138',
  GHG_139 = 'GHG_139',
  GHG_140 = 'GHG_140',
  GHG_141 = 'GHG_141',
  GHG_142 = 'GHG_142',
  GHG_143 = 'GHG_143',
  GHG_144 = 'GHG_144',
  GHG_145 = 'GHG_145',
  GHG_146 = 'GHG_146',
  GHG_147 = 'GHG_147',
  GHG_148 = 'GHG_148',
  GHG_149 = 'GHG_149',
  GHG_150 = 'GHG_150',
  GHG_151 = 'GHG_151',
  GHG_152 = 'GHG_152',
  GHG_153 = 'GHG_153',
  GHG_154 = 'GHG_154',
  GHG_155 = 'GHG_155',
  GHG_156 = 'GHG_156',
  GHG_157 = 'GHG_157',
  GHG_158 = 'GHG_158',
  GHG_159 = 'GHG_159',
  GHG_160 = 'GHG_160',
  GHG_161 = 'GHG_161',
  GHG_162 = 'GHG_162',
  GHG_163 = 'GHG_163',
  GHG_164 = 'GHG_164',
  GHG_165 = 'GHG_165',
  GHG_166 = 'GHG_166',
  GHG_167 = 'GHG_167',
  GHG_168 = 'GHG_168',
  GHG_169 = 'GHG_169',
  GHG_170 = 'GHG_170',
  GHG_171 = 'GHG_171',
  GHG_172 = 'GHG_172',
  GHG_173 = 'GHG_173',
  GHG_174 = 'GHG_174',
  GHG_175 = 'GHG_175',
  GHG_176 = 'GHG_176',
  GHG_177 = 'GHG_177',
  GHG_178 = 'GHG_178',
  GHG_179 = 'GHG_179',
  GHG_180 = 'GHG_180',
  GHG_181 = 'GHG_181',
  GHG_182 = 'GHG_182',
  GHG_183 = 'GHG_183',
  GHG_184 = 'GHG_184',
  GHG_185 = 'GHG_185',
  GHG_186 = 'GHG_186',
  GHG_187 = 'GHG_187',
  GHG_188 = 'GHG_188',
  GHG_189 = 'GHG_189',
  GHG_190 = 'GHG_190',
  GHG_191 = 'GHG_191',
  GHG_192 = 'GHG_192',
  GHG_193 = 'GHG_193',
  GHG_194 = 'GHG_194',
  GHG_195 = 'GHG_195',
  GHG_196 = 'GHG_196',
  GHG_197 = 'GHG_197',
  GHG_198 = 'GHG_198',
  GHG_199 = 'GHG_199',
  GHG_200 = 'GHG_200',
  GHG_201 = 'GHG_201',
  GHG_202 = 'GHG_202',
  GHG_203 = 'GHG_203',
  GHG_204 = 'GHG_204',
  GHG_205 = 'GHG_205',
  GHG_206 = 'GHG_206',
  GHG_207 = 'GHG_207',
  GHG_208 = 'GHG_208',
  GHG_209 = 'GHG_209',
  GHG_210 = 'GHG_210',
  GHG_211 = 'GHG_211',
  GHG_212 = 'GHG_212',
  GHG_213 = 'GHG_213',
  GHG_214 = 'GHG_214',
  GHG_215 = 'GHG_215',
  GHG_216 = 'GHG_216',
  GHG_CUSTOM_1 = 'CUSTOM_1',
  GHG_CUSTOM_2 = 'CUSTOM_2',
  GHG_CUSTOM_3 = 'CUSTOM_3',
  GHG_CUSTOM_4 = 'CUSTOM_4',
  GHG_CUSTOM_5 = 'CUSTOM_5',
  CH4_1 = 'CH4_1',
  SCENARIO = 'SCENARIO',
}

export enum TreatmentMethod {
  TM_1_R = 'TM_1_R',
  TM_2_R = 'TM_2_R',
  TM_3 = 'TM_3',
}

export enum DischargeLocation {
  DL_1 = 'DL_1',
  DL_2 = 'DL_2',
  DL_3 = 'DL_3',
  DL_4 = 'DL_4',
}
